module.exports = __webpack_public_path__ + "img/main_jlw.ded3a8ea.jpg";